<div class="col-xs-12 col-sm-6 col-lg-3 example-col">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div *ngFor="let types of this.invoiceProcessingService.downloadTypes">
      <input type="checkbox"   kendoCheckBox name="typeGroup" formControlName="{{types}}"/>
      <label class="k-label">
        {{types}}
      </label>
    </div>
  </form>
</div>
